export default {
  floatingTopMenu: {
    openSettings: 'Setări',
    about: 'Despre ORS',
    openrouteserviceAPI: 'Openrouteservice API',
    openrouteserviceForDisasters: 'Openrouteservice pentru dezastre',
    askOpenrouteservice: 'Întrebați Openrouteservice',
    showAbout: 'Afișați informații generale',
    settingsTooltip: 'Faceți clic aici dacă doriți să ajustați setările aplicației și să vedeți alte opțiuni',
  }
}
